// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

import { BENCHMARK_PROJECTS } from "./benchmarks.js";
import {
    EXPRESSIONS_PROJECTS,
    MOVIES_PROJECTS,
    NYPD_PROJECTS,
    OLYMPICS_PROJECTS,
    SF_PROJECTS,
    SUPERSTORE_PROJECTS,
} from "./blocks.js";
import { DASHBOARD_PROJECTS } from "./dashboards.js";
import { FEATURE_PROJECTS } from "./features.js";
import { MARKET_PROJECTS, WEBCAM_PROJECTS } from "./streams.js";
import type { Project } from "./types.js";

/**
 * Every saved starting point the gallery offers. Blocks first — they are the
 * interesting ones; feature variants are a long tail.
 */
export const PROJECTS: Project[] = [
    ...SUPERSTORE_PROJECTS,
    ...EXPRESSIONS_PROJECTS,
    ...NYPD_PROJECTS,
    ...SF_PROJECTS,
    ...MOVIES_PROJECTS,
    ...OLYMPICS_PROJECTS,
    ...DASHBOARD_PROJECTS,
    ...MARKET_PROJECTS,
    ...WEBCAM_PROJECTS,
    ...BENCHMARK_PROJECTS,
    ...FEATURE_PROJECTS,
];

/**
 * The Project `id` names, if the corpus has one.
 *
 * @param id a Project id, e.g. from the `?project=` route.
 */
export function projectById(id: string): Project | undefined {
    return PROJECTS.find((p) => p.id === id);
}
